import { INTERNAL_PATHS } from "routes/paths";

export const PAGE_SIZE = 50;

const SORT_LIST = [
  {
    selector: "Discount",
    label: "High to Low",
    sort: "discount",
    order: "desc"
  },
  {
    selector: "Discount",
    label: "Low to High",
    sort: "discount",
    order: "asc"
  },
  {
    selector: "Your Price",
    label: "High to Low",
    sort: "price",
    order: "desc"
  },
  { selector: "Your Price", label: "Low to High", sort: "price", order: "asc" },
  {
    selector: "Card Value",
    label: "High to Low",
    sort: "value",
    order: "desc"
  },
  { selector: "Card Value", label: "Low to High", sort: "value", order: "asc" }
];

const DEFAULT_SORTING = SORT_LIST[0];

const DEFAULT_PRICE_RANGE = {
  priceMax: "2000",
  priceMin: "5"
};

const BREADCRUMB_PATHS = [
  {
    label: "Buy Gift Cards",
    linkTo: INTERNAL_PATHS.BUY_GIFT_CARDS
  }
];

export const INITIAL_PAGINATION = {
  currentPage: 1,
  totalPages: 0,
  totalCount: 0
};

export const INITIAL_PRODUCT_SOURCE = {
  id: 0,
  name: "",
  terms: "",
  affiliate_url: ""
};

export { SORT_LIST, DEFAULT_SORTING, DEFAULT_PRICE_RANGE, BREADCRUMB_PATHS };
